import { mapAppliedDiscounts } from "./map-applied-discounts.js";
const getPrices = (orderLineItem, intl) => {
  const price = orderLineItem.price.total.gross ?? 0;
  const originalPrice = orderLineItem.price.total.subtotal ?? 0;
  const discountPrice = orderLineItem.price.total.discount.amount ?? 0;
  const tax = orderLineItem.price?.total.tax.amount ?? 0;
  const taxRate = orderLineItem.price?.unit.tax.portions[0]?.rate ?? 0;
  return {
    price,
    discountPrice,
    tax,
    taxRate,
    originalPrice,
    unitPrice: {
      price: orderLineItem.price.unit.gross ?? 0,
      originalPrice: orderLineItem.price.unit.subtotal ?? 0,
      tax: orderLineItem.price.unit.tax.amount ?? 0,
      taxRate: orderLineItem.price.unit.tax.portions[0]?.rate ?? 0,
      discountPrice: orderLineItem.price.unit.discount.amount ?? 0,
      appliedDiscounts: mapAppliedDiscounts(
        orderLineItem.price.unit.discount.appliedDiscounts,
        intl
      )
    }
  };
};
export {
  getPrices
};
//# sourceMappingURL=get-prices.js.map
